import PropTypes from 'prop-types';
import React from 'react';

const BadgeDiscount = ({ className, price, price_discount }) => {
	{
		/*const { t } = useTranslation('component_badge_discount'); */
	}
	const discountPercentage = Math.floor(
		((price - price_discount) / price) * 100,
	);
	const formattedPercentage =
		discountPercentage >= 0
			? `-${discountPercentage}%`
			: `+${Math.abs(discountPercentage)}%`;

	return (
		<>
			{Number(price_discount) > 0 && (
				<>
					<div className={`bg-danger text-white badge xxs ${className}`}>
						<span className="">{formattedPercentage}</span>
					</div>
					{/*
					<div className={`bg-red-dark text-danger badge ms-1 ${className}`}>
						<span className="">{t('t1')}</span>
					</div>
					*/}
				</>
			)}
		</>
	);
};

BadgeDiscount.propTypes = {
	className: PropTypes.string,
	discount: PropTypes.string,
	price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	price_discount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default BadgeDiscount;
